import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import {useRouter} from 'vue-router';
    import {watch ,ref} from "vue";
    import routers from '@/router';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'GoOut',
  setup(__props) {

    const router = useRouter();
    const blolks = ref(true);
    const goouts = ref(false);
    const goout = ()=>{
        if(localStorage.getItem("goout") &&(router.currentRoute.value.path === "/" || router.currentRoute.value.path === "/koudai" || router.currentRoute.value.path === "/about" )){
            router.push({
                name:"homearr"
            })
        }else{
            router.go(-1);
        }
    }
    window.addEventListener('unload', () => {
        localStorage.removeItem('goout');
    })
    watch(
  () => router.currentRoute.value.path,
  (newValue) => {
    const quertys = routers.currentRoute.value.query.goout;

    if (newValue !== "/homearr") {
      if(localStorage.getItem("goout")){
        blolks.value = true;
      }else{
        if(!quertys){
            if ((newValue === "/" || newValue === "/koudai" || newValue === "/about" || newValue === "/homearr")) {
                blolks.value = false;
            } else{
                blolks.value = true;
            }
        }else{
            blolks.value = false;
        }
      }
    }else{
        blolks.value = false;
    }
  },
  { immediate: true }
);
    

return (_ctx: any,_cache: any) => {
  return (blolks.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "returns",
        onClick: goout
      }, " 返回 "))
    : _createCommentVNode("", true)
}
}

})